import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { tryFormatDate } from '../../../common/utils/dateUtils';
import { useNavigationPaths } from '../../propertyAssociation/useNavigationPaths';
import { PinboardMessage } from '../models/GetPinboardMessagesResponse';

type Props = PinboardMessage;

const PinboardMessageItem: FunctionComponent<Props> = ({ propertyAssociationArea, publishDate, pinboardMessageId, title, usersCanRespond }) => {
    const navigate = useNavigate();
    const paths = useNavigationPaths();

    const goToEdit = () => {
        navigate(`${paths.adverts}/information/${pinboardMessageId}`);
    };

    const handleKeyPress = (keyEvent: { key: string }) => {
        if (keyEvent?.key === 'Enter') {
            goToEdit();
        }
    };

    const heading = propertyAssociationArea ? `${title} (${propertyAssociationArea.name})` : title;

    return (
        <div role="button" tabIndex={0} onKeyDown={handleKeyPress} className="hs-list__row" onClick={goToEdit}>
            <div className="col-6 ps-3">
                <h4 className="my-0">{heading}</h4>
            </div>
            <div className="col-3 d-flex align-items-center">{usersCanRespond ? 'Boende kan svara' : 'Boende kan inte svara'}</div>
            <div className="col-3 d-flex justify-content-end align-items-center">
                <div className="mx-4 px-2">{tryFormatDate(publishDate)}</div>
            </div>
        </div>
    );
};

export default PinboardMessageItem;
